import EfImg from '@elem/ui/ef-img';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.HighlightsA');
    return (
        <div className={styles.itemSelling}>
            <EfImg
                pc="https://websiteoss.ecoflow.com/upload/image/1726121329073/pc_ksp_05.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1726121329073/pc_ksp_05.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1725594663400/m_ksp_05.jpg"
            />
            <div className="item-desc-e">
                <div className="item-line-1">{t('e_ms1')}</div>
                <div className="item-line-2">{t('e_ms2')}</div>
                <div className="item-line-3">{t('e_ms3')}</div>
            </div>
        </div>
    );
}
